import * as React from "react";


export default function VitalsHistoryPage() {
  return (
     <>
    <h1>VitalsHistoryPage</h1></>
  );
}